// src/components/ui/serverSwitch.js
// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from 'react';
import {useTranslation} from 'react-i18next';
import { getActiveServers } from '../../api/axios';

export default function ServerSwitch({ value, onChange, label = 'Server' }) {
  const {t} = useTranslation();
  const [options, setOptions] = useState([]);   // [{value:'hybrid', label:'Hybrid'}, ...]
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    getActiveServers()
      .then(res => {
        if (!mounted) return;
        const list = Array.isArray(res?.data?.servers) ? res.data.servers : [];
        const mapped = list.map(s => ({
          value: s.friendly_key,                         // 'hybrid' | 'pvp' | 'saison'
          label: s.display_name || s.friendly_key,       // "Hybrid" etc.
        }));
        setOptions(mapped);
        // falls aktueller Wert nicht aktiv ist -> Auswahl leeren
        if (value && mapped.length && !mapped.find(o => o.value === value)) {
          onChange?.('');
        }
      })
      .catch(() => {
        // keine aktiven Server -> leer lassen
        setOptions([]);
      })
      .finally(() => mounted && setLoading(false));
    return () => { mounted = false; };
  }, [onChange, value]);

  return (
    <div style={{ display: 'inline-flex', gap: 8, alignItems: 'center' }}>
      {label ? <label htmlFor="server-switch">{label}</label> : null}

      <select
        id="server-switch"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        disabled={loading || options.length === 0}
        style={{ padding: '6px 10px', borderRadius: 8 }}
      >
        {loading && <option value="">Laden…</option>}
        {!loading && options.length === 0 && <option value="">{t('serverswitcher.activ')}</option>}
        {!loading && options.length > 1 && <option value="">{t('serverswitcher.server')}</option>}
        {options.map(o => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    </div>
  );
}
